import { SalesOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1671. 受注案件契約タスクフェーズ更新（前へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/move_to_prev_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  current_sales_order_contract_task_phase_id: number;
};

const moveSalesOrderContractTaskPhaseToPrev = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/move_to_prev_phase`,
    props
  );
};

export const useMoveSalesOrderContractTaskPhaseToPrev = () => {
  return useMutation({
    mutationFn: moveSalesOrderContractTaskPhaseToPrev
  });
};